import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import useSheet from '../../jss';
import icons from '../lib/ionicons';

const iconMap = icons.reduce((memo, item) => Object.assign(memo, {
  [item.value]: [item.className],
}), {});

const propTypes = {
  className: PropTypes.string,
  icon: PropTypes.oneOf(Object.keys(iconMap)),
  sheet: PropTypes.object.isRequired,
  size: PropTypes.oneOf(['default', 'large', 'medium', 'small']),
  style: PropTypes.object,
};

const defaultProps = {
  className: undefined,
  icon: undefined,
  size: 'default',
  style: {},
};

function Glyph({
  className,
  icon,
  sheet: { classes },
  size,
  style,
}) {
  return (
    <i
      className={classNames(classes.glyph, iconMap[icon], classes[size], className)}
      style={style}
    />
  );
}

Glyph.propTypes = propTypes;
Glyph.defaultProps = defaultProps;

function applyStyles() {
  return {
    glyph: {
      display: 'inline-block',
      verticalAlign: 'middle',
    },
    default: {
      fontSize: '1.5rem',
    },
    medium: {
      fontSize: '2rem',
    },
    small: {
      fontSize: '0.85rem',
    },
    large: {
      fontSize: '3rem',
    },
  };
}

export default useSheet(applyStyles)(Glyph);
